export default __webpack_public_path__ + "static/media/smiley-icon.c08bfa31.svg";